// extracted by mini-css-extract-plugin
export default {"shell":"InTaxPaystubsTable_shell__jJeYx"};